import { render, staticRenderFns } from "./ComFooter.vue?vue&type=template&id=02d0ec95&scoped=true"
import script from "./ComFooter.vue?vue&type=script&lang=js"
export * from "./ComFooter.vue?vue&type=script&lang=js"
import style0 from "./ComFooter.vue?vue&type=style&index=0&id=02d0ec95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d0ec95",
  null
  
)

export default component.exports